import * as PIXI from "pixi.js";
/**
 * PagingData.ts
 */
export class PagingData {
    constructor(totalCount, itemsPerPage, source) {
        this.totalCount = totalCount;
        this.pageIndex = 0;
        this.itemsPerPage = itemsPerPage;
        this.source = source;
        let pageResult = 0;
        if (this.totalCount > 0) {
            for (let counter = 1; pageResult < this.totalCount; counter++) {
                pageResult = counter * itemsPerPage;
                this.totalPages = counter;
            }
        }
        else {
            this.totalPages = 1;
        }
    }
    next() {
        this.pageIndex = this.pageIndex + 1 < this.totalPages ? this.pageIndex + 1 : 0;
    }
    previous() {
        this.pageIndex = this.pageIndex - 1 >= 0 ? this.pageIndex - 1 : this.totalPages - 1;
    }
    setPageIndex(value) {
        this.pageIndex = value;
    }
    range() {
        let startIndex = this.pageIndex * this.itemsPerPage;
        let endIndex = Math.min(this.totalCount, startIndex + this.itemsPerPage);
        return new PIXI.Point(startIndex, endIndex);
    }
    current() {
        let current = [];
        if (this.source) {
            let range = this.range();
            current = this.source.slice(range.x, range.y);
        }
        return current;
    }
    isActive() {
        return this.totalPages > 1;
    }
    getTotalCount() {
        return this.totalCount;
    }
    getTotalPages() {
        return this.totalPages;
    }
    getPageSize() {
        return this.itemsPerPage;
    }
    getPageIndex() {
        return this.pageIndex;
    }
}
//# sourceMappingURL=PagingData.js.map